import React from 'react';
import Image from 'next/image';
import { Typography } from '@pw-tech/omni-ui';
import { InfoIcon } from 'lucide-react';
const Waiting = () => {
  return <article data-sentry-component="Waiting" data-sentry-source-file="Waiting.tsx">
      <Typography variant="heading3" weight="semi-bold" className="mb-6" data-sentry-element="Typography" data-sentry-source-file="Waiting.tsx">
        Awaiting Result
      </Typography>
      <div className="bg-[#FEFBE8] border-2 border-[#F7E0B4] rounded-lg p-4">
        <div className="flex flex-col items-center gap-4">
          <Image src="https://static.pw.live/5eb393ee95fab7468a79d189/ADMIN/f526c671-e13a-40bc-b21e-4c493a54c23c.svg" alt="waiting" width={50} height={50} className="w-10 h-10" data-sentry-element="Image" data-sentry-source-file="Waiting.tsx" />
          <div className="mx-auto text-center">
            <Typography component="div" variant="heading4" data-sentry-element="Typography" data-sentry-source-file="Waiting.tsx">
              Awaiting Result
            </Typography>
            <Typography component="div" variant="regular" className="!text-sm !text-[#3D3D3D]" data-sentry-element="Typography" data-sentry-source-file="Waiting.tsx">
              Your result will be released very soon...
            </Typography>
          </div>
        </div>
      </div>
      <div className="flex items-center gap-2 mt-4">
        <div className="flex items-center justify-center flex-shrink-0">
          <InfoIcon size={20} data-sentry-element="InfoIcon" data-sentry-source-file="Waiting.tsx" />
        </div>
        <Typography variant="regular" className="!text-sm !text-[#757575]" data-sentry-element="Typography" data-sentry-source-file="Waiting.tsx">
          You will recieve a confirmation of the result on your registered email ID
        </Typography>
      </div>
    </article>;
};
export default Waiting;